














import { Vue, Prop, Component } from 'vue-property-decorator';
import { Colors } from 'vuetify/es5/util/colors';

@Component
export default class Button extends Vue {
  @Prop() nameButton?: string;

  @Prop() color?: Colors;

  @Prop() disabled?: Boolean;

  @Prop() loading?: Boolean;

  @Prop({ type: Boolean, default: false }) outlined !: boolean;

  click() {
    this.$emit('click');
  }
}
